import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vSelect from "vue-select"

import App from './App.vue'
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import "vue-select/dist/vue-select.css";

import SmartTable from 'vuejs-smart-table'

import Maska from 'maska'
import i18n from "./i18n"

import BootstrapVueNext from 'bootstrap-vue-next'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';
import 'nprogress/nprogress.css'; //nprogress style

import store from "./state/store";

import 'vue-json-pretty/lib/styles.css';

import "../src/design/app.scss";

const pinia = createPinia()
pinia.use((context) => {
  const storeId = context.store.$id
  const serilizer = {
    serialize: JSON.stringify,
    deserialize: JSON.parse
  }

  //sync store from localstorage
  const fromStorage = serilizer.deserialize(window.localStorage.getItem(storeId))
  if (fromStorage){
    context.store.$patch(fromStorage)
  }

  context.store.$subscribe((mutation, state) =>{
    window.localStorage.setItem(storeId, serilizer.serialize(state))
  })
})

createApp(App)
  .use(pinia)
  .use(store)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVueNext)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .use(Maska)
  .use(Vue3Toasity, { autoClose: 2000, style: { opacity: '1', userSelect: 'initial'} })
  .use(SmartTable)
  .component("v-select", vSelect)
  .mount('#app')
